import { render, staticRenderFns } from "./ChangePhoneModal.vue?vue&type=template&id=bae07528&scoped=true&"
import script from "./ChangePhoneModal.vue?vue&type=script&lang=js&"
export * from "./ChangePhoneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae07528",
  null
  
)

export default component.exports